import React from "react";
import { useParams } from 'react-router-dom';

// components

import Navbar from "components/Navbars/AuthNavbar.js";
import Analysis from "components/Analysis/Analysis";
import Footer from "components/Footers/Footer";

export default function AnalysisPage() {
    const { id } = useParams();

    return (
        <>
            <Navbar transparent />
            <main>
                <div className="relative pt-20 pb-6 flex content-center items-center justify-center min-h-screen h-full">
                    <div
                        className="absolute top-0 w-full h-full bg-center bg-cover bg-blueGray-100 z-0"
                    >
                    </div>
                    <div className="flex container content-center items-center justify-center w-full h-full z-10">
                        <Analysis id={id} />
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
}